<template>
    <el-container style="height: 800px;">
        <el-header height="180px">
            <el-row>
                <el-col :span="12"><div style="float: left;color: #fff">顧客服務熱線: 23699638</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="10"><img src='../../assets/2018_New_Logo.png'
                                      height="120px"
                                      width="120px"></el-col>
                <el-col :span="14"><div class="home-title">尖沙咀預訂<br>會議室系統</div></el-col>
            </el-row>
            <el-row>
              <el-col :span="12" :offset="12">
                    <el-popover
                      placement="bottom"
                      width="200"
                      style="float: right;">
                      <p class="info_p">FBO 編號：{{fbo_id}}</p>
                      <p class="info_p">{{current_month}}月代幣: {{current_token}}</p>
                      <p class="info_p">{{next_month}}月代幣: {{next_token}}</p>
                      <p class="info_p">電郵地址: <br>{{email}}</p>
                      <p class="info_p">電話號碼: {{mobile}}</p>
                      <div style="text-align: right; margin: 0">
                        <el-button type="primary" size="mini" @click="logout">退出</el-button>
                      </div>
                      <el-button slot="reference" size="medium" round>{{name}}</el-button>
                    </el-popover>
                </el-col>
            </el-row>
        </el-header>
        <el-container>
            <el-aside style="width: 80px">
                <el-menu :router="isRoute">
                    <el-menu-item index="/book" style="padding-left:0px">
                      <template slot="title"><i class="el-icon-edit-outline"></i><span slot="title">預訂</span></template>
                    </el-menu-item>
                    <el-menu-item index="/manage" style="padding-left:0px">
                      <template slot="title"><i class="el-icon-edit"></i><span slot="title">管理</span></template>
                    </el-menu-item>
                    <el-menu-item index="/history" style="padding-left:0px">
                      <template slot="title"><i class="el-icon-search"></i><span slot="title">歷史</span></template>
                    </el-menu-item>
                </el-menu>
            </el-aside>
            <el-main >
              <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
// import api from '@/utils/api'
import { getUserDetail } from '../../utils/api'
import {mapState, mapActions} from 'vuex'
export default {
  data () {
    return {
      isRoute: true,
      name: '',
      fbo_id: '',
      email: '',
      mobile: ''
    }
  },
  computed: {
    ...mapState('user', ['current_token', 'next_token', 'level']),
    current_month () {
      return new Date().getMonth() + 1
    },
    next_month () {
      return new Date().getMonth() + 2
    }
  },
  methods: {
    ...mapActions('user', ['changeUserInfo']),
    getuserInfo () {
      getUserDetail().then(res => {
        this.name = res.data.name
        this.fbo_id = res.data.fbo_id
        this.email = res.data.email
        this.mobile = res.data.mobile
        this.changeUserInfo({
          current_token: res.data.token_current,
          next_token: res.data.token_next,
          level: res.data.level
        })
      })
    },
    logout () {
      localStorage.clear()
      this.$router.push({name: 'login'})
    }
  },
  mounted () {
    this.getuserInfo()
  }
}
</script>

<style>
.home-title {
  margin-top: 30px;
  font-size: 25px;
  color: aliceblue
}
.el-header {
  padding: 0 0;
}
.el-row{
  margin-bottom: 10px;
}
.el-aside {
  text-align: center;
  line-height: 100px;
  margin-top: 20px
}
.el-menu {
  border-right: 0;
  background-color: rgba(0, 0, 0, 0)
}
.el-menu-item {
  font-size: 20px;
}
.el-main {
  text-align: center;
  margin-top: 20px;
  padding: 20px 0;
}
body > .el-container {
  margin-bottom: 40px;
}
p.info_p {
  margin: 4px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Home.vue